import {
  SalesOrderItemResponseType,
  SOItemsFormValues,
} from "constants/types/salesOrder";
import * as yup from "yup";
import { emptyItem, generateRowKey } from "../CreateSalesOrder/config";

export const editItemsValidationSchema = yup.object().shape({
  items: yup
    .array()
    .of(
      yup.object().shape({
        productId: yup.string().required("Vui lòng chọn sản phẩm"),
        // Tên sửa được nên bắt buộc phải kèm message; required() trống sẽ
        // chặn submit mà không hiện gì (giống form tạo mới).
        productName: yup
          .string()
          .trim()
          .required("Vui lòng nhập tên sản phẩm"),
        productUnit: yup.string().required("Sản phẩm chưa có đơn vị tính"),
        quantity: yup
          .number()
          .typeError("Vui lòng nhập số lượng")
          .positive("Số lượng phải lớn hơn 0")
          .required("Vui lòng nhập số lượng"),
        initialPrice: yup
          .number()
          .typeError("Vui lòng nhập giá gốc")
          .min(0, "Giá gốc không được âm")
          .required("Vui lòng nhập giá gốc"),
        actualPrice: yup
          .number()
          .typeError("Vui lòng nhập giá bán")
          .min(0, "Giá bán không được âm")
          .required("Vui lòng nhập giá bán"),
      }),
    )
    .min(1, "Cần ít nhất 1 sản phẩm"),
});

export const mapResponseItemsToFormValues = (
  items: SalesOrderItemResponseType[],
): SOItemsFormValues["items"] =>
  items.length > 0
    ? items.map((item) => ({
        rowKey: generateRowKey(),
        productId: item.productId,
        productName: item.productName,
        productSpec: item.productSpec ?? "",
        productUnit: item.productUnit,
        quantity: item.quantity,
        initialPrice: item.initialPrice,
        actualPrice: item.actualPrice,
      }))
    : [emptyItem()];
